import { Service } from '@onlog-public/additional-services-types';
import { AdditionServicesOptionsState } from '@pages/AdditionalServices/containers/additionServicesOptionsContext';
import {
  AServiceCache,
  AServicePropertyCache,
  AServicePropertyFilterAndOrder,
  AdditionServicesState,
} from '@pages/AdditionalServices/containers/types';

import { ServiceData, SetUpServiceData } from '../../../basket/types';
import { serviceRestoreStateGeneratorProcessor } from '../types';

/**
 * VariantPropertyValuesProcessor формирует значения свойств вариантов
 */
export class VariantPropertyValuesProcessor implements serviceRestoreStateGeneratorProcessor {
  /**
   * restore выполняет восстановление стейтов. Возвращает все стейты.
   * @param _
   * @param __
   * @param additionalServiceState
   * @param optionsState
   * @param serviceCacheState
   * @param servicePropertyCacheState
   * @param servicePropertyFilterAndOrderState
   */
  async restore(
    _: SetUpServiceData,
    __: (SetUpServiceData | ServiceData)[],
    additionalServiceState: AdditionServicesState,
    optionsState: AdditionServicesOptionsState,
    serviceCacheState: AServiceCache,
    servicePropertyCacheState: AServicePropertyCache,
    servicePropertyFilterAndOrderState: AServicePropertyFilterAndOrder
  ) {
    const servicesByDir: { directoryID: string; services: Service[] }[] = [];
    const propertyValues = { ...additionalServiceState.PropertyValues };

    Object.entries(additionalServiceState.VariantServices).forEach(([dirId, services]) => {
      servicesByDir.push({ directoryID: dirId, services });
    });

    additionalServiceState.Variants.map((variant) => {
      propertyValues[variant.id] = {};

      additionalServiceState.PropertiesToDisplay.map((prop) => {
        propertyValues[variant.id][prop.id] = [];
      });

      const props = additionalServiceState.VariantProperties[variant.id] ?? [];
      props.map((prop) => {
        propertyValues[variant.id][prop.id] = [];
      });
    });

    servicesByDir.map((r) => {
      r.services.map((s) => {
        s.property_values.map((value) => {
          if (!propertyValues[r.directoryID][String(value.property_id)]) {
            return;
          }

          propertyValues[r.directoryID][String(value.property_id)].push(value.value);
        });
      });
    });

    return {
      isValid: true,
      additionalServiceState: {
        ...additionalServiceState,
        PropertyValues: propertyValues,
      },
      optionsState,
      serviceCacheState,
      servicePropertyCacheState,
      servicePropertyFilterAndOrderState,
    };
  }
}
